import guest from './guest.page.js'
import user from './user.page.js'
import admin from './admin.page.js'
import access from './access.page.js'

export const pages = {
  guest,
  user,
  access
}

export const adminpages = {
  admin
}